import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "cc_admin_token";

export const getToken = () => {
  try { return window.localStorage.getItem(TOKEN_KEY); } catch (_) { return null; }
};

export const setToken = (t) => {
  try { window.localStorage.setItem(TOKEN_KEY, t); } catch (_) {}
};

export const clearToken = () => {
  try { window.localStorage.removeItem(TOKEN_KEY); } catch (_) {}
};

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const login = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  setToken(data.token);
  return data.user;
};

export const me = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const logout = () => clearToken();

export const adminGet = async (path) => {
  const { data } = await axios.get(`${API}/admin/${path}`, { headers: authHeader() });
  return data;
};

export const adminPost = async (path, body = {}) => {
  const { data } = await axios.post(`${API}/admin/${path}`, body, { headers: authHeader() });
  return data;
};
